module.exports = __webpack_public_path__ + "static/media/UnlockCorporateServicesBanner.e735461d.svg";